export default function Copy (props) {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -2 10 12" stroke={props.stroke} className={props.className} style={props.style}  >
            <path d="M 0 2 C 0 0 0 0 2 0 C 2 -1 2 -1 3 -1 L 5 -1 C 6 -1 6 -1 6 0 C 6 1 6 1 5 1 L 3 1 C 2 1 2 1 2 0 M 6 0 C 8 0 8 0 8 2 L 8 7 C 8 9 8 9 6 9 L 2 9 C 0 9 0 9 0 7 L 0 2 M 2 4 L 6 4 M 2 6 L 6 6"/>
        </svg>
    )

}